// lib/device/store.ts
var emptyState = { blocked: false };
var state = emptyState;
var listeners = /* @__PURE__ */ new Set();
var reportDeviceUnauthorized = (deviceId) => {
  state = { blocked: true, deviceId };
  listeners.forEach((listener) => listener());
};
var clearDeviceUnauthorized = () => {
  if (!state.blocked) return;
  state = emptyState;
  listeners.forEach((listener) => listener());
};
var subscribeDeviceUnauthorized = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};
var getDeviceUnauthorizedSnapshot = () => state;
var resetDeviceUnauthorizedStateForTesting = () => {
  state = emptyState;
  listeners.clear();
};

export {
  reportDeviceUnauthorized,
  clearDeviceUnauthorized,
  subscribeDeviceUnauthorized,
  getDeviceUnauthorizedSnapshot,
  resetDeviceUnauthorizedStateForTesting
};
